import React, { useEffect, useState } from "react";
import NavigationServicesHeader from "../../../Header/NavigationServicesHeader";
import * as OFMSUI from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { Formik, ErrorMessage, useFormik, FormikProvider, Field, FieldArray, } from "formik"; import { Form, FormControl, FormGroup, FormLabel, Row, Col, Table, Button, Modal, } from "react-bootstrap";
import HousingService from "../../../Services/HousingService";
import moment from "moment-timezone";
import { store } from "../../../App";
import { FaDownload, FaEdit, FaFastBackward } from "react-icons/fa";
import { ConnectedFocusError } from "focus-formik-error";
import * as Yup from "yup";
import { cloud_url, cloud_url_download } from "../../../Services/Configuration";
import { InputGroup } from "reactstrap";
import { AiFillMinusCircle, AiFillPlusCircle } from "react-icons/ai";
import { BsPatchCheckFill } from "react-icons/bs";
import Swal from "sweetalert2";
import axios from "axios";
import { GetDetails, handleFileChange, LabelHeader, ModuleHeader, todayDate } from "../../utils/commonFunctions";
import axiosTokenServiceKeyCloak from "../../../Services/axiosTokenServiceKeyCloak";

const JourrnalVoucherEdit = () => {
  const history = useHistory();
  const [distList, setDistList] = useState();
  const [distData, setDistData] = useState([]);
  const [savedistCode, setsaveDistCode] = useState("");
  const [JournalDetails, setJournalDetails] = useState([]);
  const [hiddenIcons, setHiddenIcons] = useState({});
  const [TableEnable, setTableEnable] = useState(false);
  const [editEnable, setEditEnable] = useState(false);
  const [headNamesList, setheadNamesList] = useState([]);
  const [SubHeadsList, setSubHeadsList] = useState([]);
  // const [uploadedFile, setUploadedFile] = useState(null);
  const [code, setCode] = useState("");
  const [uploadCopy, setUploadCopy] = useState("");


  useEffect(() => {
    HousingService.CGG_District().then((res) => {
      if (res.data) {
        setDistData(res.data);
        let options = res.data.map((item, i) => {
          return (
            <option key={i} value={item.code}>
              {item.name}
            </option>
          );
        });
        setDistList(options);
      }
    });
    HousingService.fetchHeadNamesDropdowns().then((res) => {
      store.dispatch({ type: "SHOW_SPINNER" });
      if (res.data) {
        const extractedHeadOptions = res.data.map((item) => {
          return (
            <option value={item.headid}>
              {item.heads}
            </option>
          );
        });

        setheadNamesList(extractedHeadOptions);
        store.dispatch({ type: "HIDE_SPINNER" });
      }
    });
  }, []);

  const SubHeads = (e, rowIndex) => {
    const headid = e.target.value;

    if (headid !== "0") {
      HousingService.fetchSubHeadName(headid).then((res) => {
        if (res.data) {
          const extractedSubHeadOptions = res.data.map((item) => (
            <option key={item.subheadseqid} value={item.subheadseqid}>
              {item.subheads}
            </option>
          ));

          setSubHeadsList((prev) => {
            const updatedSubHeadLists = [...prev];
            updatedSubHeadLists[rowIndex] = extractedSubHeadOptions || [];
            return updatedSubHeadLists;
          });
        }
      });
    }
  }
  const validate = Yup.object({
    payment_receipt_id: Yup.string().required("Transaction Id is Required")
  });
  const formik1 = useFormik({
    initialValues: {
      fromDate: "",
      toDate: "",
      district: "",
      payment_receipt_id: "",
    },
    validationSchema: validate,
    onSubmit: (values) => {
      store.dispatch({ type: "SHOW_SPINNER" });
      if (values.payment_receipt_id === "") {
        setsaveDistCode(values.district)
        let params = { payment_receipt_id: "", };
        setCode(values.district)
        console.log("code:", values.district)
        HousingService.GetJV_Edit_data(params).then((res) => {
          if (res && res.data) { setJournalDetails(res.data); setTableEnable(true); setEditEnable(false) }
        });
      }
      else {
        let params1 = { payment_receipt_id: values.payment_receipt_id };
        HousingService.GetJV_Edit_data(params1).then((res) => {
          if (res && res.data) {
            setJournalDetails(res.data);
            setTableEnable(true);
            setEditEnable(false);
            setCode(res.data[0].security_id);
            setsaveDistCode(res.data[0].security_id);
          }
        }).finally(() => {
          store.dispatch({ type: "HIDE_SPINNER" });
        })
          ;
      }
    },
  });
  const showNotification = (type, message) => {
    if (type === "success") {
      Swal.fire("Success", message, "success");
    } else if (type === "error") {
      Swal.fire("Error", message, "error");
    } else if (type === "warning") {
      Swal.fire("Warning", message, "warning");
    } else if (type === "info") {
      Swal.fire("info", message, "info");
    }
  };
  const fileDownload = (upload_copy, index) => {
    if (upload_copy == null) {
      showNotification("error", "No File Uploaded");
    } else {
      setHiddenIcons((prevHiddenIcons) => ({
        ...prevHiddenIcons,
        [index]: true
      }));

      axiosTokenServiceKeyCloak({
        url: `${cloud_url_download}apofmslive/journalentry&file=${encodeURIComponent(upload_copy)}`,
        method: "GET",
        responseType: "blob"
      })
        .then((response) => {
          const blob = new Blob([response.data], {
            type: response.headers["content-type"]
          });

          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = upload_copy;

          link.click();

          window.URL.revokeObjectURL(link.href);

          setHiddenIcons((prevHiddenIcons) => ({
            ...prevHiddenIcons,
            [index]: false
          }));
        })
        .catch((error) => {
          console.error("Error downloading file:", error);
          setHiddenIcons((prevHiddenIcons) => ({
            ...prevHiddenIcons,
            [index]: false
          }));
          if (error.response && error.response.status === 500) {
            showNotification(
              "An error occurred while downloading the file",

            );
          } else {
            showNotification(
              "error",
              "File Was Deleted, Upload the File Again"
            );
          }
        });
    }
  };



  const getPdf = (payment_receipt_id) => {
    HousingService.getjournalpdf(payment_receipt_id).then((res) => {
      const url = window.URL.createObjectURL(
        new Blob([res.data], { type: "application/pdf" })
      );

      let tab = window.open();

      tab.location.href = url;
      setTimeout(() => {
        resetForm();
        window.location.reload();
      }, 2000);
    });
  };

  const validationSchema = Yup.object({
    date: Yup.string().required("Required"),
    // upload_copy: Yup.string().required("Required"),
    voucher_id: Yup.string().required(),
    description: Yup.string().required("Head ID is required"),
    dummy_journal_voucher_heads_Req: Yup.array().of(
      Yup.object().shape({
        headid: Yup.string().required("Head ID is required"),
        credit: Yup.number()
          .required("Credit amount is required")
          .typeError("Credit amount should be a number"),
        debit: Yup.number()
          .required("Debit amount is required")
          .typeError("Debit amount should be a number"),
      })
    ),
  });
  const formik = useFormik({
    initialValues: {
      payment_receipt_id: "",
      date: "",
      voucher_id: "",
      description: "",
      debit: "",
      credit: "",
      upload_copy: "",
      dummy_journal_voucher_heads_Req: [
        {
          jvslno: "",
          headid: "",
          subheadid: "",
          debit: "",
          credit: "",
        },
      ],
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      console.log("values", values)
      handleApprove()
    },
  });

  const EditData = async (payment_receipt_id) => {
    store.dispatch({ type: "SHOW_SPINNER" });
    const params = { payment_receipt_id: payment_receipt_id, };
    try {
      const [journalVoucherData, subHeadsData] = await Promise.all([HousingService.GetJournalVochersReport_DataById(params), HousingService.GetSubHeadsDataforGJ_Manger(params),]);

      if (journalVoucherData && journalVoucherData.data) {
        const data = journalVoucherData.data[0];
        formik.setFieldValue("payment_receipt_id", data.payment_receipt_id);
        formik.setFieldValue("voucher_id", data.voucher_id);
        formik.setFieldValue("date", moment(data.to_char, "DD/MM/YYYY").format("YYYY-MM-DD"));
        formik.setFieldValue("description", data.description);
        formik.setFieldValue("credit", data.credit);
        formik.setFieldValue("debit", data.debit);
        formik.setFieldValue("upload_copy", data.upload_copy == "" || data.upload_copy == null || data.upload_copy == undefined ? "" : data.upload_copy);
        setUploadCopy(data.upload_copy);
        console.log("data.upload_copy", data.upload_copy);
      }

      if (subHeadsData.data[0].responseToken === 1) {
        subHeadsData.data[0].HeadsListData.forEach((key, i) => {
          formik.setFieldValue(`dummy_journal_voucher_heads_Req[${i}].jvslno`, key.jvslno);
          formik.setFieldValue(`dummy_journal_voucher_heads_Req[${i}].credit`, parseInt(key.credit || 0));
          formik.setFieldValue(`dummy_journal_voucher_heads_Req[${i}].debit`, parseInt(key.debit || 0));

          const headid = key.headid;

          HousingService.fetchSubHeadName(headid).then((res) => {
            if (res.data) {
              const extractedSubHeadOptions = res.data.map((item) => (
                <option key={item.subheadseqid} value={item.subheadseqid}>
                  {item.subheads}
                </option>
              ));

              setSubHeadsList((prevSubHeadLists) => {
                const updatedSubHeadLists = [...prevSubHeadLists];
                updatedSubHeadLists[i] = extractedSubHeadOptions;
                return updatedSubHeadLists;
              });
            }
          });

          formik.setFieldValue(`dummy_journal_voucher_heads_Req[${i}].headid`, key.headid);
          formik.setFieldValue(`dummy_journal_voucher_heads_Req[${i}].subheadid`, key.subheadid);
        });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setTableEnable(false);
      setEditEnable(true);
      store.dispatch({ type: "HIDE_SPINNER" });
    }
  };

  const handleApprove = async () => {
    const totalDebit = formik.values.dummy_journal_voucher_heads_Req.reduce(
      (sum, item) => sum + parseInt(item.debit || 0),
      0
    );
    const totalCredit = formik.values.dummy_journal_voucher_heads_Req.reduce(
      (sum, item) => sum + parseInt(item.credit || 0),
      0
    );
    if (totalCredit == totalDebit) {
      let file = document.getElementById("file").files[0];
      if (!file) {
        console.log("1");
        let params = {
          payment_receipt_id: formik.values.payment_receipt_id, voucher_id: formik.values.voucher_id, date: formik.values.date, description: formik.values.description, debit: totalDebit, credit: totalCredit, upload_copy: uploadCopy,
          dummy_journal_voucher_heads_Req: formik.values.dummy_journal_voucher_heads_Req.map(item => ({
            ...item,
            security_id: savedistCode
          })),
        };
        Swal.fire({
          text: "Are you sure?", icon: "question", showCancelButton: true, confirmButtonColor: "#3085d6", cancelButtonColor: "#d33", confirmButtonText: "Yes",
        }).then((result) => {
          if (result.isConfirmed) {
            HousingService.Journal_Voucher_Edit(params).then(
              async (res) => {
                if (res?.data?.SCODE === "01") {
                  showNotification("success", "Updated successfully"); await getPdf(params?.payment_receipt_id);
                  setTimeout(() => { window.location.reload(); }, 1000);
                }
              }
            );
          }
        });
      }
      else {
        console.log("12");
        Swal.fire({ text: "Are you sure?", icon: "question", showCancelButton: true, confirmButtonColor: "#3085d6", cancelButtonColor: "#d33", confirmButtonText: "Yes", }).then(async (result) => {
          if (result.isConfirmed) {
            // STEP – 1: Upload file
            let formData = new FormData(); formData.append("file", file);
            try {
              const uploadRes = await HousingService.fileUploadUrlJV(formData);
              if (!uploadRes?.data) { 
                showNotification("error", "File upload failed"); return; }
              // STEP – 2: Prepare params using uploaded file response
              let params = {
                payment_receipt_id: formik.values.payment_receipt_id, voucher_id: formik.values.voucher_id, date: formik.values.date, description: formik.values.description, debit: totalDebit, credit: totalCredit, upload_copy: uploadRes?.data,
                dummy_journal_voucher_heads_Req: formik.values.dummy_journal_voucher_heads_Req.map(item => ({
                  ...item,
                  security_id: savedistCode
                })),
              };
              // STEP – 3: Call next API
              const apiRes = await HousingService.Journal_Voucher_Edit(params);
              if (apiRes?.data?.SCODE === "01") {
                showNotification("success", "Updated successfully");
                await getPdf(params.payment_receipt_id);
                setTimeout(() => { window.location.reload(); }, 1000);
              }
            } catch (err) {
              console.error(err);
              showNotification("error", "Something went wrong");
            }
          }
        });
      }
    }
    else {
      showNotification("error", "Creidt and Debit Should be Equal");
    }
  };
  const handleFileChangee = (e) => {
    const file = e.target.files[0];
    if (file) {
      const validType = ["application/pdf", "image/jpeg", "image/jpg", "image/png"]; const maxSize = 2 * 1024 * 1024;
      if (validType.includes(file.type)) {
        if (file.size > maxSize) {
          ShowAlert("File Size Exceeds The Limit Of 2 MB Only", "error"); e.target.value = ""; return false;
        }
        else {
          formik.setFieldValue("upload_copy", file)
        }
      }
      else {
        ShowAlert("Only PDF and Image Files Are Allowed", "error"); e.target.value = "";
      }
    }
  };
  return (
    <div>
      <NavigationServicesHeader />
      <ModuleHeader title="Journal Voucher Edit" />
      <OFMSUI.Container className="outer-page-content-container" fluid style={{ width: "90%" }} >
        <FormikProvider value={formik1}>
          <Form onSubmit={formik1.handleSubmit}>
            <OFMSUI.Row>
              <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2}>
                <LabelHeader title="Transaction Id" />
                <Field type="text" name="payment_receipt_id" className={formik1.touched.payment_receipt_id && formik1.errors.payment_receipt_id ? "form-control is-invalid" : "form-control"} ></Field>
                <ErrorMessage name="payment_receipt_id" className="text-error" component="div" />
              </OFMSUI.Col>
              <GetDetails />
            </OFMSUI.Row>
            {TableEnable && (
              <>
                <OFMSUI.Row>
                  <Table striped bordered hover id="my-table" style={{ marginTop: "50px" }}>
                    <thead className="fw-bold">
                      <tr className="table_countshead">
                        <th>S No.</th>
                        <th>Transaction Id</th>
                        <th>Voucher No.</th>
                        <th>Voucher Date</th>
                        <th>Description of the Voucher</th>
                        <th className="text-center">Debit</th>
                        <th className="text-center">Credit</th>
                        <th className="text-center">Download file</th>
                        <th className="text-center">Edit</th>
                      </tr>
                    </thead>
                    <tbody>
                      {JournalDetails && JournalDetails?.length > 0 ? (JournalDetails.map((tableData, index) => (
                        <tr key={index}>
                          <td style={{ width: "10px" }}>{index + 1}</td>
                          <td style={{ width: "50px" }}> {" "} {tableData.payment_receipt_id} </td>
                          <td style={{ width: "50px" }}>{tableData.voucher_id}</td>
                          <td style={{ width: "50px" }}>{tableData.date}</td>
                          <td style={{ width: "300px" }}> {tableData.description} </td>
                          <td style={{ width: "50px" }} className="sum text-right"> {tableData.debit} </td>
                          <td style={{ width: "50px" }} className="sum text-right"> {tableData.credit} </td>
                          <td style={{ fontSize: "21px", color: "green", textAlign: "center", width: "50px", }} > {!hiddenIcons[index] && (<FaDownload onClick={() => fileDownload(tableData.upload_copy, index)} />)} </td>
                          <td style={{ width: "10px" }} className="text-center"> <button type="button" onClick={() => { EditData(tableData.payment_receipt_id); }} className="btn btn-primary" > <FaEdit /> </button> </td>
                        </tr>
                      ))) : (<tr><td colSpan={9} className="text-center">No data Found</td></tr>)}
                    </tbody>
                  </Table>

                </OFMSUI.Row>
              </>

            )}
          </Form>
        </FormikProvider>
        {editEnable && (
          <div>
            <br></br>
            <FormikProvider value={formik}>
              <Form onSubmit={formik.handleSubmit}>
                <OFMSUI.Row className="p-4">
                  <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-3" >
                    <LabelHeader title="Transaction Id" />
                    <Field type="text" name="payment_receipt_id" disabled={true} className={formik.touched.payment_receipt_id && formik.errors.payment_receipt_id ? "form-control is-invalid" : "form-control"} ></Field>
                  </OFMSUI.Col>
                  <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-3" >
                    <LabelHeader title="Voucher No." />
                    <Field
                      type="text"
                      name="voucher_id"
                      className={formik.touched.voucher_id && formik.errors.voucher_id ? "form-control is-invalid" : "form-control"}
                    ></Field>
                    <ErrorMessage name="voucher_id" className="text-error" component="div" />
                  </OFMSUI.Col>
                  <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-3" >
                    <LabelHeader title="Received Date" />
                    <Field
                      type="date"
                      name="date"
                      max={todayDate}
                      className={formik.touched.date && formik.errors.date ? "form-control is-invalid" : "form-control"}
                    ></Field>
                    <ErrorMessage name="date" className="text-error" component="div" />
                  </OFMSUI.Col>
                  <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="mb-3" >
                    <LabelHeader title="Description" />
                    <span className="mandatory" style={{ color: "red" }}> {" "} *{" "} </span>
                    <Field
                      as="textarea"
                      name="description"
                      className={formik.touched.description && formik.errors.description ? "form-control is-invalid" : "form-control"}
                    />
                    <ErrorMessage name="textarea" className="text-error" component="div" />
                  </OFMSUI.Col>
                  <OFMSUI.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className="m-2" >
                    <label> <b>File Upload (File name should not contain symbols or special characters.)</b> <span className="text-danger">*</span> </label>
                    <InputGroup>
                      <input
                        type="file"
                        id="file"
                        name="upload_copy"
                        onChange={(e) => { handleFileChangee(e); formik.handleChange(e) }}
                        className="form-control"
                        accept=".pdf"
                      />
                    </InputGroup>
                    <ErrorMessage name="upload_copy" className="text-error" component="div" />
                  </OFMSUI.Col>
                </OFMSUI.Row>
                <OFMSUI.Row className="p-4" style={{ marginTop: "-25px" }}>
                  <Table striped bordered hover>
                    <tbody> <thead style={{ color: "#004687", marginRight: "85%", backgroundColor: "red", }} className="fw-bold" ></thead> </tbody>
                  </Table>
                  <Table striped bordered hover>
                    <thead className="fw-bold">
                      <tr>
                        <td>S.no</td>
                        <td style={{ display: "none" }}>JV Sl. No.</td>
                        <td style={{ width: "50%" }}>Heads Name</td>
                        <td style={{ width: "15%" }}>SubHeads Name</td>
                        <td>Debit</td>
                        <td>Credit</td>
                        <td>Actions</td>
                      </tr>
                    </thead>
                    <tbody>
                      <FieldArray name="dummy_journal_voucher_heads_Req">
                        {({ push, remove }) => (
                          <>
                            {formik.values.dummy_journal_voucher_heads_Req.map((member, i) => (
                              <tr key={i}>
                                <td>{i + 1}</td>
                                <td>
                                  <Field
                                    as="select"
                                    className={
                                      formik.touched.dummy_journal_voucher_heads_Req?.[i]?.headid &&
                                        formik.errors.dummy_journal_voucher_heads_Req?.[i]?.headid
                                        ? "form-control is-invalid"
                                        : "form-control"
                                    }
                                    name={`dummy_journal_voucher_heads_Req[${i}].headid`}
                                    onChange={(e) => {
                                      formik.handleChange(e);
                                      SubHeads(e, i);
                                    }}
                                  >
                                    <option value="">Select</option>
                                    {headNamesList}
                                  </Field>
                                  <ErrorMessage
                                    name={`dummy_journal_voucher_heads_Req[${i}].headid`}
                                    component="div"
                                    className="text-error"
                                  />
                                </td>
                                <td>
                                  <Field
                                    as="select"
                                    className={
                                      formik.touched.dummy_journal_voucher_heads_Req?.[i]?.subheadid &&
                                        formik.errors.dummy_journal_voucher_heads_Req?.[i]?.subheadid
                                        ? "form-control is-invalid"
                                        : "form-control"
                                    }
                                    name={`dummy_journal_voucher_heads_Req[${i}].subheadid`}
                                  >
                                    <option value="">Select</option>
                                    {Array.isArray(SubHeadsList[i]) && SubHeadsList[i].map((option) => option)}
                                  </Field>
                                  <ErrorMessage
                                    name={`dummy_journal_voucher_heads_Req[${i}].subheadid`}
                                    component="div"
                                    className="text-error"
                                  />
                                </td>
                                <td>
                                  <Field type="text" name={`dummy_journal_voucher_heads_Req[${i}].debit`} className="form-control" />
                                  <ErrorMessage name={`dummy_journal_voucher_heads_Req[${i}].debit`} component="div" className="text-error" />
                                </td>
                                <td>
                                  <Field type="text" name={`dummy_journal_voucher_heads_Req[${i}].credit`} className="form-control" />
                                  <ErrorMessage name={`dummy_journal_voucher_heads_Req[${i}].credit`} component="div" className="text-error" />
                                </td>
                                <td>
                                  <AiFillPlusCircle
                                    style={{ fontSize: "21px", color: "green", cursor: "pointer" }}
                                    onClick={() => push({ headid: "", subheadid: "", debit: "", credit: "" })}
                                  />
                                  <AiFillMinusCircle
                                    style={{ fontSize: "21px", color: "red" }}
                                    onClick={() => {
                                      let credit = formik.values.credit - formik.values.dummy_journal_voucher_heads_Req[i].credit;
                                      let debit = formik.values.debit - formik.values.dummy_journal_voucher_heads_Req[i].debit;
                                      let params = {
                                        payment_receipt_id: formik.values.payment_receipt_id,
                                        credit: credit,
                                        debit: debit,
                                        security_id: code,
                                        headid: formik.values.dummy_journal_voucher_heads_Req[i].headid,
                                        subheadid: formik.values.dummy_journal_voucher_heads_Req[i].subheadid,
                                      };
                                      Swal.fire({
                                        text: "Are you sure to delete?",
                                        icon: "question",
                                        showCancelButton: true,
                                        confirmButtonColor: "#3085d6",
                                        cancelButtonColor: "#d33",
                                        confirmButtonText: "Yes",
                                      }).then((result) => {
                                        if (result.isConfirmed) {
                                          remove(i);
                                          HousingService.RowRemoveApi(params).then(async (res) => {
                                            if (res?.data?.SCODE === "01") {
                                              showNotification("success", "Deleted Successfully");
                                            }
                                          });
                                        }
                                      });
                                    }}
                                  ></AiFillMinusCircle>
                                </td>
                              </tr>
                            ))}
                          </>
                        )}
                      </FieldArray>



                    </tbody>
                    <tfoot>
                      <tr>
                        <th colSpan={3}>Total</th>
                        <th> {formik.values?.dummy_journal_voucher_heads_Req?.reduce((sum, row) => parseFloat(row?.debit || 0) + sum, 0)} </th>
                        <th> {formik.values?.dummy_journal_voucher_heads_Req?.reduce((sum, row) => parseFloat(row?.credit || 0) + sum, 0)} </th>
                      </tr>
                    </tfoot>
                  </Table>

                  <OFMSUI.Row>
                    <OFMSUI.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className="mb-3" ></OFMSUI.Col>
                    <OFMSUI.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className="mb-3" > <button type="submit" className="btn btn-success" > Update <BsPatchCheckFill /> </button> </OFMSUI.Col>
                  </OFMSUI.Row>
                </OFMSUI.Row>
              </Form>
            </FormikProvider>
          </div>
        )}
      </OFMSUI.Container>
    </div>
  );
};

export default JourrnalVoucherEdit;
